// const api = `${process.env.REACT_APP_BASE_URL}/api`;
const api = `https://ia-api.winw.com.br/`; // prod
// const api = `http://127.0.0.1:8000/`; // dev

export const PecasApi = `${api}api/pecas`;
export const StorageApi = `${api}storage`;
export const LoginURL = `${api}api/login`;
export const DownloadAPIPrivada = `${api}api/download`;